import { AbTestVariant } from '~/models/AbTest/AbTest'

export default () => {
    return useCookie<AbTestVariant[]>('abTests', {
        maxAge: 2592000, // 30 days
        secure: true,
    })
}
